// extracted by mini-css-extract-plugin
export default {"formFieldMediumSlim":"IAQInsight2BuildingInfo_formFieldMediumSlim__4ds04"};